import React, { useState } from 'react';

import Button from 'components/Button';
import Input from 'components/Input';
import { TEXT_COMMON, TEXT_USER_LIST } from 'constants/string/texts';
import { getCodeJapaneseGovernmentsWith, getJapaneseGovernments } from 'utils/helper';

const UserListHeader = ({ options, onChange }) => {
  const japanese_government = getJapaneseGovernments() || [];
  const [activeFilter, setActiveFilter] = useState(false);
  const [municipality, setMunicipality] = useState(null);

  const handleItemOverview = () => {
    const from = (options.page - 1) * options.page_size + 1;
    const to = from + options.page_size - 1;
    const total = options.total;

    return `${from} - ${to > total ? total : to} / ${total} ${TEXT_USER_LIST.PART}`;
  };

  const submitFilter = () => {
    onChange({ municipality_code: municipality ? [getCodeJapaneseGovernmentsWith(municipality, true)] : null });
  };

  const onClear = () => {
    setMunicipality(null);
    onChange({ municipality_code: null });
  };

  return (
    <>
      <div className="flex items-end justify-between gap-2 mt-2">
        <p className="text-sm opacity-85 text-gray-336">{handleItemOverview()}</p>
        <div className="flex space-x-4">
          <Button
            className={`text-sm filter w-35.5 h-10 ${activeFilter ? 'text-primary-346 border-primary-346' : ''}`}
            onClick={() => setActiveFilter(!activeFilter)}
            icon={
              activeFilter ? (
                <div className="relative mr-2.5">
                  {options.municipality_code && <div className="w-2 h-2 absolute top-0 right-0 bg-danger-229 rounded-full"></div>}
                  <img src={require('assets/resources/FilterAltActive.svg').default} alt="plus icon" width={18} height={18} />
                </div>
              ) : (
                <div className="relative mr-2.5">
                  {options.municipality_code && <div className="w-2 h-2 absolute top-0 right-0 bg-danger-229 rounded-full"></div>}
                  <img src={require('assets/resources/FilterAlt.svg').default} alt="plus icon" width={18} height={18} />
                </div>
              )
            }
            text={TEXT_USER_LIST.TEXT_FILTER}
            color="outline"
          />
        </div>
      </div>
      <div className={`${activeFilter ? 'h-54.25' : 'h-0'} overflow-hidden transition-all`}>
        <div className="w-full mt-6">
          <div className="border-2 border-primary-423 p-4 rounded-md h-47.25">
            <div className="flex-between-center">
              <p className="font-bold">{TEXT_USER_LIST.TEXT_FILTER}</p>
              <div className="cursor-pointer" onClick={() => setActiveFilter(false)}>
                <img src={require('assets/resources/Close.svg').default} alt="close" width={24} height={24} />
              </div>
            </div>
            <p className="text-sm mt-4 mb-2">{TEXT_USER_LIST.TEXT_FILTER_TYPE}</p>
            <div className="w-64">
              <Input
                onSelect={(e) => {
                  setMunicipality(e);
                }}
                onChange={(e) => {
                  setMunicipality(e);
                }}
                allowClear={true}
                onClickClear={onClear}
                value={municipality}
                name="municipality"
                classNameInput="!h-10"
                className="w-full"
                type="autocomplete"
                placeholder={TEXT_USER_LIST.TEXT_FILTER_TYPE}
                options={japanese_government}
                filterOption={(inputValue, option) =>
                  option.value &&
                  (option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 ||
                    option.code.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1)
                }
              />
            </div>
            <div className="mt-4 flex-end-center">
              <Button onClick={submitFilter} color="primary" type="button" className="w-20 h-8">
                <span className="text-sm">{TEXT_COMMON.EXECUTION}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(UserListHeader);
